import { useEffect, useState } from "react";
import { getBook } from "../data/books";
import { useApp } from "../context/AppContext";
import { api, ApiError } from "../lib/api";
import { centsToDollars } from "@shared/pricing";
import type { PublicOrder } from "@shared/types";

export function ConfirmPage({ orderNumber }: { orderNumber: string }) {
  const { go } = useApp();
  const [order, setOrder] = useState<PublicOrder | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.getOrder(orderNumber);
        if (!cancelled) setOrder(res.order);
      } catch (err) {
        if (!cancelled) setError(err instanceof ApiError ? err.message : "Could not load order");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [orderNumber]);

  return (
    <main className="confirm-page">
      <div className="stamp">✓</div>
      <h1>
        Thank you, <span className="it">{order?.shipping.first || "friend"}.</span>
      </h1>
      <p className="lead">
        Your books are off to the press. We've sent a receipt to{" "}
        <b style={{ color: "var(--ink)" }}>{order?.email ?? "your email"}</b>. Estimated arrival: 7–10 days.
      </p>
      <div className="confirm-card">
        <h3>Order number</h3>
        <div className="order-no">{orderNumber}</div>
        {error && (
          <div className="mono" style={{ color: "var(--rust)", marginTop: 12 }}>
            {error}
          </div>
        )}
        {order && (
          <>
            <div className="items">
              {order.items.map((item, idx) => {
                const book = getBook(item.bookId);
                if (!book) return null;
                return (
                  <div key={idx} className="it-row">
                    <div>
                      <span>{book.titleSecond}</span>
                      <div className="for">For {item.name}</div>
                    </div>
                    <div>${centsToDollars(item.priceCents)}</div>
                  </div>
                );
              })}
            </div>
            <div
              style={{
                marginTop: 18,
                borderTop: "1px solid var(--line)",
                paddingTop: 14,
                display: "flex",
                justifyContent: "space-between",
                fontFamily: "var(--serif)",
                fontWeight: 500,
                fontSize: 20,
              }}
            >
              <span>Total {order.status === "paid" ? "paid" : "(pending)"}</span>
              <span>${centsToDollars(order.totalCents)}</span>
            </div>
          </>
        )}
      </div>
      <button className="btn btn-ghost" style={{ marginTop: 36 }} onClick={() => go({ name: "home" })}>
        Back to the bookshop
      </button>
    </main>
  );
}
